import { createSlice } from '@reduxjs/toolkit';
import { createReducerNames } from '../../../core/helpers/default';

const name = 'createCategory';

const reducersKeys = {
  createRequest: 'createRequest',
  createSuccess: 'createSuccess',
  createFailure: 'createFailure',
};

const initialState = {
  showModal: false,
  created: false,
  loading: false,
  error: null,
};

const slice = createSlice({
  name,
  initialState,
  reducers: {
    [reducersKeys.createRequest]: (state) => {
      state.loading = true;
    },
    [reducersKeys.createSuccess]: (state) => {
      state.loading = false;
      state.showModal = false;
      state.created = true;
    },
    [reducersKeys.createFailure]: (state, { payload }) => {
      state.loading = false;
      state.error = payload.error;
    },
    openModal: (state) => {
      state.created = false;
      state.showModal = true;
    },
    closeModal: (state) => {
      state.showModal = false;
    },
  },
});

export const createCateforyReducer = createReducerNames(name, reducersKeys);
export const { actions } = slice;

export default slice.reducer;
